import { render, staticRenderFns } from "./DeviceCard.vue?vue&type=template&id=73636b04"
import script from "./DeviceCard.vue?vue&type=script&lang=js"
export * from "./DeviceCard.vue?vue&type=script&lang=js"
import style0 from "./DeviceCard.vue?vue&type=style&index=0&id=73636b04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports